<div class="p-d-flex">
  <kodit-field fieldLabel="Izaberite tip poslovanja: " fieldLabelFor="tipPoslovanja">
    <div class="flex-1" style="">
      <kodit-dropdown
        formCtrlId="tipPoslovanja"
        [options]="tipPoslovanjaOptions"
        (optionChanged)="handleOptionChanged($event)"
      ></kodit-dropdown>
    </div>
  </kodit-field>
</div>

<kodit-page *ngIf="optionSelected === TipPoslovanja.KPO">
  <kodit-kpo-knjiga-table></kodit-kpo-knjiga-table>
</kodit-page>

<!--<kodit-info-container>-->
<!--  &lt;!&ndash; Tabela &ndash;&gt;-->
<!--  <kodit-kpo-knjiga-table body-2-of-3></kodit-kpo-knjiga-table>-->

<!--  &lt;!&ndash; PDF &ndash;&gt;-->
<!--  <kodit-kpo-knjiga-pdf body-1-of-3></kodit-kpo-knjiga-pdf>-->
<!--</kodit-info-container>-->
